import type { ManagerPerm } from '../types'

/**
 * Ayarlar bölümlerinin hangi izne bağlı olduğu (müdür, 3 Kas 2026). Patron
 * hepsini görür; Hesabım (paket, abonelik, kurumu silme) yalnız patronun.
 */
export const SECTION_PERM: Record<string, ManagerPerm | 'owner'> = {
  hesap: 'owner',
  staff: 'staff',
  kampanya: 'menu',
  receipt: 'settings',
  screens: 'settings',
  kiosk: 'settings',
  sadakat: 'settings',
  qr: 'settings',
  printers: 'settings',
  tables: 'settings',
}

export function canSeeSection(
  id: string,
  isOwner: boolean,
  can: (perm: ManagerPerm) => boolean,
): boolean {
  if (isOwner) return true
  const need = SECTION_PERM[id] ?? 'settings'
  return need !== 'owner' && can(need)
}
